import React from 'react';
import { CheckCircle2, Target, Eye } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from '../components/ui/card';

const About = () => {
  const { t } = useLanguage();

  const strengths = [
    t('strength1'),
    t('strength2'),
    t('strength3'),
    t('strength4'),
  ];

  return (
    <div className="min-h-screen pt-24 pb-20">
      {/* Hero */}
      <section className="bg-[#141F48] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('aboutTitle')}</h1>
          <p className="text-xl text-[#D3BC8D] font-medium">{t('aboutSubtitle')}</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">{t('aboutText1')}</p>
              <p className="text-lg text-gray-700 leading-relaxed">{t('aboutText2')}</p>
              <p className="text-lg text-gray-700 leading-relaxed">{t('aboutText3')}</p>
            </div>
            <div>
              <div className="rounded-lg shadow-xl overflow-hidden">
                <img
                  src="/assets/images/about-tower.jpg"
                  alt="ALMAD Tower - Symbol of Excellence"
                  className="w-full h-[400px] object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#141F48] mb-4">{t('missionVisionTitle')}</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <Card className="border-2 border-[#D3BC8D] hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-[#141F48] rounded-lg flex items-center justify-center mb-4">
                  <Target className="w-6 h-6 text-[#D3BC8D]" />
                </div>
                <h3 className="text-2xl font-bold text-[#141F48] mb-4">{t('mission')}</h3>
                <p className="text-gray-600 leading-relaxed">{t('missionText')}</p>
              </CardContent>
            </Card>
            <Card className="border-2 border-[#D3BC8D] hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8">
                <div className="w-12 h-12 bg-[#141F48] rounded-lg flex items-center justify-center mb-4">
                  <Eye className="w-6 h-6 text-[#D3BC8D]" />
                </div>
                <h3 className="text-2xl font-bold text-[#141F48] mb-4">{t('vision')}</h3>
                <p className="text-gray-600 leading-relaxed">{t('visionText')}</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Core Strengths */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-[#141F48] text-center mb-12">
            {t('coreStrengths')}
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {strengths.map((strength, index) => (
              <Card key={index} className="border-2 border-[#D3BC8D] hover:shadow-lg transition-shadow duration-300">
                <CardContent className="p-6 text-center">
                  <CheckCircle2 className="w-12 h-12 text-[#D3BC8D] mx-auto mb-4" />
                  <h3 className="text-lg font-semibold text-[#141F48]">{strength}</h3>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;